import React from 'react';
import Icon from '../../../components/AppIcon';
import PhaseCard from './PhaseCard';

const PhaseTimeline = ({ phases, team, onUpdatePhase, userRole, onNavigateToPhase }) => {
  const isBoss = userRole === 'boss';

  const getVisiblePhases = () => {
    if (isBoss) return phases;
    return phases?.filter(phase => 
      phase?.assignedTo?.some(id => 
        team?.find(member => member?.id === id && member?.role === userRole)
      )
    );
  };

  const visiblePhases = getVisiblePhases();

  const getPhaseStats = () => {
    const total = phases?.length;
    const completed = phases?.filter(p => p?.status === 'completed')?.length;
    const inProgress = phases?.filter(p => p?.status === 'in_progress')?.length;
    const delayed = phases?.filter(p => p?.hasAlert)?.length;
    return { total, completed, inProgress, delayed };
  };

  const stats = getPhaseStats();

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
          <Icon name="ListChecks" size={20} strokeWidth={2} />
          Renovation Phases
          {!isBoss && <span className="text-sm font-normal text-muted-foreground">(Your Assignments)</span>}
        </h2>
        <div className="flex items-center gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-success" />
            <span className="text-muted-foreground">Completed: {stats?.completed}</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary" />
            <span className="text-muted-foreground">In Progress: {stats?.inProgress}</span>
          </div>
          {stats?.delayed > 0 && (
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-error" />
              <span className="text-muted-foreground">Delayed: {stats?.delayed}</span>
            </div>
          )}
        </div>
      </div>
      {visiblePhases?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="Inbox" size={48} className="mx-auto mb-4 text-muted-foreground" strokeWidth={1.5} />
          <h3 className="text-lg font-semibold text-foreground mb-2">No Phases Assigned</h3>
          <p className="text-sm text-muted-foreground">
            {isBoss 
              ? 'Start by assigning team members to phases' :'You have not been assigned to any phases yet'}
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {visiblePhases?.map((phase) => (
            <PhaseCard
              key={phase?.id}
              phase={phase}
              team={team}
              onUpdate={onUpdatePhase}
              userRole={userRole}
              onNavigateToPhase={onNavigateToPhase}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PhaseTimeline;